import Vue from 'vue'
import axios from 'axios'
// import VueAxios from 'vue-axios'
import App from './App.vue'
import router from './routes'
import vuetify from './plugins/vuetify';
import store from './store/store'

Vue.config.productionTip = false

// Vue.use(VueAxios, axios)

new Vue({
  router,
  vuetify,
  store,
  axios,
  render: h => h(App)
}).$mount('#app')
